import Header from '../component/header';
import { Hero } from '../component/hero';
import { Footer } from '../component/footer';
import { ContactForm } from '../component/contact/contactform';

function ContactUs() {
  return (
    <>
    <div className="App">
    <Header/>
    <ContactForm/>   
    <Footer/>
     
    </div>
    </>
  );
}

export default ContactUs;
